/** localStorage flag: staff opted into Web Push on this device. */
const PUSH_ENABLED_KEY = 'pixie-push-enabled';

function getStorage(storage) {
  if (storage) return storage;
  try {
    if (typeof localStorage !== 'undefined') return localStorage;
  } catch (_) {
    /* ignore */
  }
  return null;
}

function persistPushEnabled(enabled, storage) {
  const s = getStorage(storage);
  if (!s) return;
  try {
    if (enabled) s.setItem(PUSH_ENABLED_KEY, '1');
    else s.removeItem(PUSH_ENABLED_KEY);
  } catch (_) {
    /* quota / private mode */
  }
}

function wasPushEnabled(storage) {
  const s = getStorage(storage);
  if (!s) return false;
  try {
    return s.getItem(PUSH_ENABLED_KEY) === '1';
  } catch (_) {
    return false;
  }
}

/**
 * Settings panel status. After PWA Install the live PushSubscription is
 * dropped with the old service worker; keep showing Enabled when opt-in
 * was persisted so the label is not overwritten to "push not active".
 */
function pushStatusLabel({ pushActive, permission, wasEnabled }) {
  if (pushActive || (permission === 'granted' && wasEnabled)) {
    return 'Enabled (push active)';
  }
  if (permission === 'granted') return 'Permission granted (push not active)';
  if (permission === 'denied') return 'Blocked';
  if (permission === 'default') return 'Not enabled';
  return 'Unsupported';
}

function shouldPromptStaffPush({ supported, permission } = {}) {
  if (!supported) return false;
  return permission === 'default' || permission === 'denied';
}

function shouldKeepPushActive({ restored, permission, wasEnabled }) {
  if (permission !== 'granted') return false;
  if (restored) return true;
  return !!wasEnabled;
}

/**
 * applyPwaUpdate unregisters the SW (drops the browser subscription) but
 * leaves pixie-pwa-updating in storage. On the next boot, permission is
 * still "granted" — persist opt-in so Settings stays Enabled while we
 * resubscribe to the new worker.
 */
function rememberPushEnabledAfterPwaUpdate({ permission, pwaUpdating }, storage) {
  if (permission === 'granted' && pwaUpdating) {
    persistPushEnabled(true, storage);
    return true;
  }
  return wasPushEnabled(storage);
}

function pushRestoreRetryDelaysMs() {
  return [0, 1000, 2000, 4000, 8000];
}

module.exports = {
  PUSH_ENABLED_KEY,
  persistPushEnabled,
  wasPushEnabled,
  pushStatusLabel,
  shouldKeepPushActive,
  shouldPromptStaffPush,
  rememberPushEnabledAfterPwaUpdate,
  pushRestoreRetryDelaysMs,
};
